<template>
  <view-loader :loading="!!loading">
    <div class="portlet-body form">
      <form class="form-horizontal" role="form">
        <div class="form-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="col-md-4 control-label">Baza:</label>
                <div class="col-md-8">
                  <single-select
                      v-model="formBase"
                      :options="bases"
                      name="base"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="col-md-4 control-label">Nazwa pliku:</label>
                <div class="col-md-8">
                  <single-select
                      v-model="formType"
                      :options="types"
                      name="type"
                      @change="onFormTypeChange"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="col-md-4 control-label">Data od:</label>
                <div class="col-md-8">
                  <date-picker
                      v-model="formDateFrom"
                      :time="false"
                      :is-nullable="true"
                      :can-clear="true"
                      :init-value="false"
                      :disabled="formDateDisabled"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="col-md-4 control-label">Data do:</label>
                <div class="col-md-8">
                  <date-picker
                      v-model="formDateTo"
                      :time="false"
                      :is-nullable="true"
                      :can-clear="true"
                      :init-value="false"
                      :disabled="formDateDisabled"
                  />
                  <span v-if="errorFormDate" class="help-block" style="color: red">
                      <p> {{ errorFormDate }} </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 pl-0">
              <button
                  type="button"
                  :disabled="!isValid"
                  class="btn btn-primary"
                  @click="generate">
                Pobierz
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </view-loader>
</template>

<script>
import ViewLoader from '@component/ViewLoader.vue'
import axios from 'axios'
import SingleSelect from '@component/singleselect.vue'
import DatePicker from '@component/datePicker.vue'
import FileDownload from 'js-file-download'

export default {
  name: 'FormD365',
  components: {
    SingleSelect,
    ViewLoader,
    DatePicker,
  },
  data() {
    return {
      loading: false,
      formBase: null,
      formType: null,
      formDateFrom: null,
      formDateTo: null,
      formDateDisabled: false,
      errorFormDate: '',
      types: [
        {
          'id': 'formula-PS',
          'name': 'Formuły PS'
        },
        {
          'id': 'formula-PK',
          'name': 'Formuły PK'
        },
        {
          'id': 'TH_PK_PS_SF_SU',
          'name': 'TH_PK_PS_SF_SU'
        },
        {
          'id': 'nutritional-values',
          'name': 'Wartości Odżywcze'
        },
        {
          'id': 'variants',
          'name': 'Warianty Produktów'
        },
        {
          'id': 'product-translations',
          'name': 'Tłumaczenia produktów'
        },
        {
          'id': 'dietetics-for-released-product-variants',
          'name': 'Opisy dla wypuszczonych wariantów produktów'
        },
        {
          'id': 'formula-headers',
          'name': 'Nagłówki formuł'
        },
        {
          'id': 'released-products-v2',
          'name': 'Wydane Produkty V2'
        },
        {
          'id': 'formula-headers-and-versions-v3',
          'name': 'Nagłówki i wersje formuł V3'
        },
        {
          'id': 'formula-lines-v2',
          'name': 'Linie formuł V2'
        },
        {
          'id': 'formula-versions-v2',
          'name': 'Wersje formuł V2'
        },
      ],
      bases: [
        {
          'id': 'sk',
          'name': 'Syty król',
        },
        {
          'id': 'ntfy',
          'name': 'NTFY',
        },
        {
          'id': 'all',
          'name': 'wszystkie',
        },
      ],
    }
  },
  computed: {
    isValid() {
      let isValid = true
      this.errorFormDate = ''

      if (!this.formBase) {
        isValid = false
      }

      if (!this.formType) {
        isValid = false
      }

      if (this.formDateFrom && !this.formDateTo) {
        isValid = false
      }

      if (!this.formDateFrom && this.formDateTo) {
        isValid = false
      }

      if (this.formDateFrom && this.formDateTo) {
        let startDate = Date.parse(this.formDateFrom)
        let endDate = Date.parse(this.formDateTo)
        let maxDate = startDate + 60 * 60 * 24 * 730 * 1000
        if (startDate > endDate) {
          this.errorFormDate = '"Data od" nie może być większa niż "Data do"'
          isValid = false
        }

        if (maxDate < endDate) {
          this.errorFormDate = 'Maksymalny zakres dat to 2 lata'
          isValid = false
        }
      }

      return isValid
    }
  },
  methods: {
    onFormTypeChange(value) {
      if (value === 'nutritional-values') {
        this.formDateDisabled = true
        this.formDateFrom = null
        this.formDateTo = null
      } else {
        this.formDateDisabled = false
      }
    },
    generate() {
      this.loading = true

      const url = Routing.generate('api_import_d365')
      const data = {
        base: this.formBase,
        type: this.formType,
        dateFrom: this.formDateFrom,
        dateTo: this.formDateTo
      }

      axios.post(url, data, {responseType: 'blob'}).then(response => {
        const filename = response.headers['content-disposition'].split('filename=')[1] || (this.formType + '.xlsx')
        FileDownload(response.data, filename)
      }, response => {
        toastr.error('Wystąpił błąd podczas generowania raportu')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
